import loadable from "@loadable/component";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

import ErrorBoundary from "components/ErrorBoundary";
import Layout from "components/Layout/Layout";

import AuthRedirect from "./AuthRedirect";

const AboutUs = loadable(() => import("pages/about-us"));
const Account = loadable(() => import("pages/account/account"));
const Apply = loadable(() => import("pages/apply"));
const BugReport = loadable(() => import("pages/bug-report"));
const Chat = loadable(() => import("pages/chat"));
const ConfirmPassword = loadable(() => import("pages/confirm-password"));
const ContactUs = loadable(() => import("pages/contact-us"));
const Default = loadable(() => import("pages/default/default"));
const Faq = loadable(() => import("pages/faq"));
const ForgotPassword = loadable(() => import("pages/forgot-password"));
const Index = loadable(() => import("pages/index/index"));
const Privacy = loadable(() => import("pages/privacy"));
const Recs = loadable(() => import("pages/recs/recs"));
const SignIn = loadable(() => import("pages/signin"));
const SignUp = loadable(() => import("pages/signup"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />} path="/">
      <Route element={<Index />} ErrorBoundary={ErrorBoundary} index />
      <Route element={<AuthRedirect />} ErrorBoundary={ErrorBoundary} path="__/auth/action" />
      <Route element={<AboutUs />} ErrorBoundary={ErrorBoundary} path="about-us" />
      <Route element={<Account />} ErrorBoundary={ErrorBoundary} path="account" />
      <Route element={<Apply />} ErrorBoundary={ErrorBoundary} path="apply" />
      <Route element={<BugReport />} ErrorBoundary={ErrorBoundary} path="bug-report" />
      <Route element={<Chat />} ErrorBoundary={ErrorBoundary} path="chat" />
      <Route element={<ConfirmPassword />} ErrorBoundary={ErrorBoundary} path="confirm-password" />
      <Route element={<ContactUs />} ErrorBoundary={ErrorBoundary} path="contact-us" />
      <Route element={<Faq />} ErrorBoundary={ErrorBoundary} path="faq" />
      <Route element={<ForgotPassword />} ErrorBoundary={ErrorBoundary} path="forgot-password" />
      <Route element={<Privacy />} ErrorBoundary={ErrorBoundary} path="privacy" />
      <Route element={<Recs />} ErrorBoundary={ErrorBoundary} path="recs" />
      <Route element={<SignIn />} ErrorBoundary={ErrorBoundary} path="signin" />
      <Route element={<SignUp />} ErrorBoundary={ErrorBoundary} path="signup" />
      <Route element={<Default />} ErrorBoundary={ErrorBoundary} path=":dir" />
      <Route element={<Default />} ErrorBoundary={ErrorBoundary} path=":dir/:page" />
      <Route element={<Default />} ErrorBoundary={ErrorBoundary} path=":dir/:page/:subpage" />
    </Route>
  )
);

const Router = () => {
  if (localStorage.getItem("test_keattz") === "true") {
    throw new Error("Test Error");
  }
  return <RouterProvider router={router} />;
};

export default Router;
